const actions = {
  setDates: "setDates",
  setFromDate: "setFromDate",
  setToDate: "setToDate"
} as const;

const mutations = {
  setFromDate: "setFromDate",
  setToDate: "setToDate"
} as const;

export const WeekSelectorStore = {
  actions: {
    [actions.setDates](context, { fromDate, toDate }) {
      context.commit(mutations.setFromDate, fromDate);
      context.commit(mutations.setToDate, toDate);
    },

    [actions.setFromDate](context, fromDate) {
      context.commit(mutations.setFromDate, fromDate);
    },

    [actions.setToDate](context, toDate) {
      context.commit(mutations.setToDate, toDate);
    }
  },

  mutations: {
    [mutations.setFromDate](state, fromDate) {
      state.fromDate = fromDate;
    },

    [mutations.setToDate](state, toDate) {
      state.toDate = toDate;
    }
  },

  namespaced: true,

  state() {
    return {
      fromDate: "",
      toDate: ""
    };
  }
};
